import React, {
	useEffect
}from 'react'
import {
	useDispatch, useSelector
}from 'react-redux'
import {
	Route, Routes as Switch
}from 'react-router-dom'
import {
	userActions
}from './store/actions/user'
import {
	homeLoadables,
	accountLoadables,
	newsLoadables
}from "./loadables"
import ReInfoOrg from './containers/ReInfoOrg'
import Nri from './containers/NRI'
import NotFound from './components/NotFound'
import HelpSection from './containers/HelpSection/'
import ReConstructionMaterialPeriodPrices from './containers/ReConstructionMaterialPeriodPrices'
import ReConstructionMaterial from './containers/NRI/ReConstructionMaterial'
import OneNews from './containers/News/OneNews'
import OneHelp from './containers/HelpSection/OneHelp/OneHelp'
import HelpList from './containers/HelpSection/HelpList'
import Weights from './containers/Report/ReSpecificWeight/index'
import PricesForPeriods from './containers/ReOrgConstructionMaterialPricePeriodChange/pricesByPeriods'

const Routes = () => {
	const dispatch = useDispatch()
	const { user } = useSelector(state => state.userReducer)
	useEffect(() => {
	 	dispatch(userActions.refreshUserData({}))
	 }, [])

	return (
		<Switch>
			<Route
				exact
				element={ <homeLoadables.LoadableHome /> }
				path="/"
			/>
			{ Boolean(user?.isLoggedIn) &&
			(
				<Route
					exact
					element={ <accountLoadables.LoadableAccount /> }
					path="/account"
				/>
			) }
			<Route
				element={ <ReConstructionMaterialPeriodPrices /> }
				path="/basePrices"
			/>
			<Route
				element={ (
					<Nri
						withHeader
						withCatalog={ false }
					/>
				) }
				path="/nsi"
			/>
			<Route
				element={ (
					<ReConstructionMaterial
						withHeader
					/>
				) }
				path="/catalog"
			/>
			<Route
				element={ (
					<ReInfoOrg
						isModify={ false }
					/>
				) }
				path="/infoOrganizations"
			/>
			<Route
				element={ (
					<HelpSection
						isModify={ false }
					/>
				) }
				path="/help"
			/>
			<Route
				element={ <OneNews /> }
				path="/oneNews/:newsId"
			/>
			<Route
				element={ (<HelpSection />) }
				path="/help"
			>
				<Route
					element={ <HelpList /> }
					path=""
				/>
				<Route
					element={ <OneHelp /> }
					path=":id"
				/>
			</Route>
			<Route
				element={ <newsLoadables.LoadableAddNews /> }
				path="/createNews"
			/>
			<Route
				element={ <newsLoadables.LoadableAddNews /> }
				path="/editNews/:id"
			/>
			<Route
				exact
				element={ <NotFound /> }
				path="*"
			/>
		</Switch>
	)
}

export default Routes